import { NgModule } from '@angular/core';

import { Routes, RouterModule, Route } from '@angular/router';
import {
  ActivateComponent,
  AuthGuard,
  RoleGuard,
  LayoutComponent,
  LoginComponent,
  LogoutComponent,
  RequestPasswordResetComponent,
  ResetPasswordComponent,
} from '@groceriya/auth/feature';
import { UserRole } from '@groceriya/models';

const authRoutes: Route[] = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'login',
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'logout',
        component: LogoutComponent,
      },
      {
        path: 'activate',
        component: ActivateComponent,
      },
      {
        path: 'request-password-reset',
        component: RequestPasswordResetComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent,
      },
    ],
  },
];

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
    data: {
      allowedRoles: [UserRole.SystemAdmin],
    },
    canActivate: [AuthGuard, RoleGuard],
  },
  {
    path: 'auth',
    children: authRoutes,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
